import React from 'react'
import {Context as AppContext} from '../../contexts/App'
import {Context as SalesChannelsContext} from '../../contexts/SalesChannels'
import GroupedSalesForm from './GroupedSalesForm'

import Stack from '@mui/material/Stack'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Paper from '@mui/material/Paper'
import Toolbar from '@mui/material/Toolbar'
import Typography from '@mui/material/Typography'
import Tooltip from '@mui/material/Tooltip'
import IconButton from '@mui/material/IconButton'
import AddIcon from '@mui/icons-material/Add'
import FilterListIcon from '@mui/icons-material/FilterList'
import FilterListOffIcon from '@mui/icons-material/FilterListOff'
import EditIcon from '@mui/icons-material/Edit'
import DeleteIcon from '@mui/icons-material/Delete'
import CircularProgress from '@mui/material/CircularProgress'
import Box from '@mui/material/Box'

const StockCostToolbar = (props) => {
  const { selected, add, remove, edit, vendor,  } = props
  const [deleteDialog, setDeleteDialog] = React.useState(false)
  const deleteConfirmation = () => setDeleteDialog(true)
  const confirmDelete = () => remove(selected._id) || setDeleteDialog(false)
  const closeDelete = () => setDeleteDialog(false)

  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
      }}
    >
      <Typography
        sx={{ flex: '1 1 100%' }}
        variant="h6"
        id="tableTitle"
        component="div"
      >
        <Dialog onClose={closeDelete} open={deleteDialog}>
          <DialogTitle>Eliminar</DialogTitle>
          <Button onClick={confirmDelete}>Ok</Button>
        </Dialog>
      </Typography>
      {selected && 
        <React.Fragment>
          <Tooltip title="Editar">
            <IconButton onClick={() => edit(selected._id)}>
              <EditIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Eliminar">
            <IconButton onClick={deleteConfirmation}>
              <DeleteIcon />
            </IconButton>
          </Tooltip>
        </React.Fragment>
      }

      <Tooltip title="Agrupar ventas">
        <IconButton onClick={add} disabled={!vendor}>
          <AddIcon />
          {!vendor && "Seleccione un canal de venta"}
        </IconButton>
      </Tooltip>


    </Toolbar>
  )
}

const GroupedSales = () => {
  const { vendor,  } = React.useContext(AppContext)
  const SalesChannel = React.useContext(SalesChannelsContext)  
  const { current } = SalesChannel
	const { groupedSales, detail, removeGroupedSales } = SalesChannel.events
  const [open, setOpen] = React.useState(false)
  const close = () => {
    detail(null)
    setOpen(false)
  }
  const openD = (s) => {
    setOpen(true)
  }
  const openAdd = () => {
    close()
    openD()
  }
  return (
    <Stack>
      <StockCostToolbar vendor={vendor} selected={current} add={openAdd} edit={openD} remove={removeGroupedSales}/>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell alignt="left">Canal</TableCell>
              <TableCell alignt="left">Ventas</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!groupedSales && <CircularProgress size={27}/>}
            {groupedSales && groupedSales.map((groupedSale) => (
              <TableRow
                selected={current && current._id ==groupedSale._id?true:false}
                onClick={() => current && current._id == groupedSale._id?detail(false):detail(groupedSale)}
                key={groupedSale._id}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
              >
                <TableCell align="left">{groupedSale.vendor}</TableCell>
                <TableCell align="left"><Box>{groupedSale.sales.map((gs) =>(<Typography>{gs}</Typography>))}</Box></TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <GroupedSalesForm model={current} open={open} close={close}/>
    </Stack>
  )
}
export default GroupedSales